import cs from './compiled/cs.json';
import en from './compiled/en.json';

export const messages = {
	cs,
	en,
};

export type Locale = keyof typeof messages;
